/* @ngInject */
export function exceptionInterceptorConfig($httpProvider) {
    $httpProvider.interceptors.push(($q, $window) => {
        return {
            responseError: (response) => {
                if (response.data === 'WORKER_NAME_REQUIRED') {
                    $window.postMessage({
                        type: 'WORKER_NAME_REQUIRED'
                    }, '*');
                }
                if (response.data === 'IP_BLOCKED') {
                    $window.postMessage({
                        type: 'IP_BLOCKED'
                    }, '*');
                }
                if (response.data === 'NO_INSTALLATION_USER') {
                    $window.postMessage({
                        type: 'NO_INSTALLATION_USER'
                    }, '*');
                }
                return $q.reject(response);
            }
        };
    });
}

/* @ngInject */
export function workerNameRequiredEventListener($window, $state){
    $window.addEventListener('message', (message) => {
        if (message.data.type === 'WORKER_NAME_REQUIRED') {
            $state.go('workerNameRequired');
        }
    });
}

/* @ngInject */
export function ipBlockedEventListener($window, $state){
    $window.addEventListener('message', (message) => {
        if (message.data.type === 'IP_BLOCKED') {
            $state.go('ipBlocked');
        }
    });
}

/* @ngInject */
export function NoInstallationUserEventListener($window, $state){
    $window.addEventListener('message', (message) => {
        if (message.data.type === 'NO_INSTALLATION_USER') {
            $state.go('NoInstallationUser');
        }
    });
}

locationProviderConfig.$inject = ['$locationProvider'];

export function locationProviderConfig($locationProvider) {
    $locationProvider.html5Mode(true);
}

translateProviderConfig.$inject = ['$translateProvider', 'CONTEXT_PATH'];

export function translateProviderConfig($translateProvider, CONTEXT_PATH) {
    $translateProvider
        .useCookieStorage()
        .useUrlLoader(CONTEXT_PATH + '/authentication/translations')
        .preferredLanguage('da')
        .fallbackLanguage('en')
        .useSanitizeValueStrategy('sanitizeParameters')
        .registerAvailableLanguageKeys(['en', 'da'], {
            'en_*': 'en',
            'da_*': 'da'
        });
}

uibTooltipProviderConfig.$inject = ['$uibTooltipProvider'];

export function uibTooltipProviderConfig($uibTooltipProvider) {
    $uibTooltipProvider.options({
        appendToBody: true
    });
}

uiRouterStateChangeErrorHandler.$inject = ['$rootScope', '$log'];

export function uiRouterStateChangeErrorHandler($rootScope, $log) {
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
        $log.error(error);
    });
}

cookiesProviderConfig.$inject = ['$cookiesProvider', 'CONTEXT_PATH'];

export function cookiesProviderConfig($cookiesProvider, CONTEXT_PATH) {
    $cookiesProvider.defaults.path = CONTEXT_PATH;
}
